export const COLORS = {
  Text: {
    Primary: "#1A1A1A", // Dark neutral for readability
    Dark: "#2d2d2d",
    Secondary: "#f6f7f9", // Softer gray for less emphasis
    Inverse: "#FFFFFF", // For text on dark backgrounds
    Muted: "#9CA3AF", // Subtle, tertiary text
  },
  Background: {
    Primary: "#FFFFFF", // Clean base
    Secondary: "#F5F5F5", // Light gray for sections
    Tertiary: "#E5E7EB", // Divider / card background
    Dark: "#111827", // Dark mode / overlays
  },
  Brand: {
    Primary: "#4361ee",
    Secondary: "#191918",
    Accent: "#FF5733", // Vibrant accent (orange)
  },
  Status: {
    Success: "#28A745", // Green
    Warning: "#FFC107", // Amber
    Error: "#DC3545", // Red
    Info: "#17A2B8", // Cyan
  },
  Palette: {
    Blue: "#007BFF",
    Indigo: "#6610F2",
    Purple: "#6F42C1",
    Pink: "#E83E8C",
    Teal: "#00695C",
    Yellow: "#FFC300",
    Red: "#DC3545", // Red
    LightGreen: "#d4edda", // Green
    MediumGreen: "#28A745",
    LightRed: "#f8d7da", // Red
    MediumRed: "#dc3545",
    LightYellow: "#fff3cd",
    MediumYellow: "#ffc107",
    DarkYellow: "#e0a800",
    Danger: "#e8192d",
  },
  Neutral: {
    White: "#FFFFFF",
    Gray: "#6C757D",
    DarkGray: "#343A40",
    LightGray: "#f6f7f8",
  },
  Transparent: {
    LightGray: "#D2D2D277",
    LightGray25: "#d2d2d2ff",
    White25: "#FFFFFF40",
    White65: "#FFFFFF65",
    BlueSky: "#C2E9FB40",
    LightGreen: "#4361ee37",
    BrandPrimary: "#e2ecffff",
  },
  Interaction: {
    Hover: "#2E3545",
    Focus: "#007E6E80", // Semi-transparent brand color
    Disabled: "#9CA3AF80", // Muted gray
  },

  OrderStatusText: {
    PENDING: "#ec8805",
    CONFIRMED: "#08516eff",
    DELIVERED: "#28A745",
    UPLOADED: "#08516eff",

    CANCELED: "#e8192d",
    RETURNED: "#DC3545",
    EXCHANGED: "#6F42C1",
    IN_TRANSIT: "#086e5fff",
    OUT_FOR_DELIVERY: "#082a6eff",
    SHIPPED: "#77561aff",
    TENTATIVE: "#ec8805",
  },

  OrderState: {
    PENDING: "#fef2d0",
    CONFIRMED: "#bee3f8",
    Delivered: "#d4edda",
    UPLOADED: "#bee3f8",
    Canceled: "#f8d7da",
    Returned: "#fdf3f2",
    EXCHANGED: "#f3e5f5",
    IN_TRANSIT: "#f9fdffff",
    OUT_FOR_DELIVERY: "#ffffffff",
    SHIPPED: "#081c28ff",
    TENTATIVE: "#fef2d0",
  },
};
